import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type { SignalTimeframeDTO } from "../SignalTimeframeDTO";

export const isFilterWithTimeframe = <F extends SignalFilters>(filters: F): filters is F & SignalTimeframeDTO => {
    return "period" in filters && "periodAmount" in filters;
};
